// Разпознаване на „широк уеб“ — от този праг приложението спира да е
// телефонно оформление и става система със странична навигация.

import { Platform, useWindowDimensions } from 'react-native';

export const WIDE_BREAKPOINT = 1024;

export function useWide(): boolean {
  const { width } = useWindowDimensions();
  return Platform.OS === 'web' && width >= WIDE_BREAKPOINT;
}
